export default {
  SECTION_WIDGET_IMAGE_GALLERY: {
    layout01: {
      cellWidth: {
        100: {
          allow: true,
          item: 4,
        },
        66.67: {
          allow: true,
          item: 2,
        },
        58.33: {
          allow: true,
          item: 2,
        },
        50: {
          allow: true,
          item: 2,
        },
        41.67: {
          allow: true,
          item: 1,
        },
        33.33: {
          allow: true,
          item: 1,
        },
        25: {
          allow: true,
          item: 1,
        },
        20: {
          allow: false,
        },
        16.66: {
          allow: false,
        },
      },
    },
    layout02: {
      cellWidth: {
        100: {
          allow : true,
          item: 3
        },
        66.67: {
          allow: true,
          item: 2,
        },
        58.33: {
          allow: true,
          item: 2,
        },
        50: {
          allow: true,
          item: 2,
        },
        41.67: {
          allow: true,
          item: 1,
        },
        33.33: {
          allow: true,
          item: 1,
        },
        25: {
          allow: true,
          item: 1,
        },
        20: {
          allow: false,
        },
        16.66: {
          allow: false,
        },
      },
    },
    layout03: {
      cellWidth: {
        100: {
          allow: true,
          item: 1,
        },
        66.67: {
          allow: true,
          item: 1,
        },
        58.33: {
          allow: true,
          item: 1,
        },
        50: {
          allow: true,
          item: 1,
        },
        41.67: {
          allow: true,
          item: 1,
        },
        33.33: {
          allow: true,
          item: 1,
        },
        25: {
          allow: true,
          item: 1,
        },
        20: {
          allow: false,
        },
        16.66: {
          allow: false,
        },
      },
    },
  },
};
